module.exports = __webpack_public_path__ + "static/media/reports_acknowledgment.a3a936e4.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_acknowledgment.md
// module id = 1107
// module chunks = 0